import React from 'react';
import PropTypes from 'prop-types';
import HomeIndemnityListSection from './HomeIndemnityListSection';
import { getBondUpdateUrl } from '../../../globals/utils/homeHelpers';

/** Pending indemnity signatures list (Professional Guardian Home). */
export default function PgHomeIndemnitySection({
  indemnityCopy,
  bonds,
  loadingIndemnity,
  markingBondId,
  onMarkClick,
}) {
  return (
    <HomeIndemnityListSection
      copy={indemnityCopy}
      bonds={bonds}
      loadingIndemnity={loadingIndemnity}
      markingBondId={markingBondId}
      onMarkClick={onMarkClick}
      resolveBondUrl={(bond) => getBondUpdateUrl(bond.bond_type, bond.bond_id)}
    />
  );
}

PgHomeIndemnitySection.propTypes = {
  indemnityCopy: PropTypes.shape({
    title: PropTypes.string,
    subtitle: PropTypes.string,
    emptyList: PropTypes.string,
    view: PropTypes.string,
    markCompleted: PropTypes.string,
  }).isRequired,
  bonds: PropTypes.arrayOf(PropTypes.object).isRequired,
  loadingIndemnity: PropTypes.bool.isRequired,
  markingBondId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onMarkClick: PropTypes.func.isRequired,
};
